import React, { useState, useEffect, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown, faInfoCircle } from '@fortawesome/free-solid-svg-icons'
import { FaTimes } from 'react-icons/fa'
import Tippy from '@tippyjs/react'
import 'tippy.js/dist/tippy.css'

import "./ShockSelector.scss"

function ShockSelector({model, shocks, setShocks, items = []}) {

    const [open, setOpen] = useState(false)
    let dropdownRef = useRef()

    useEffect(() => {

        let handler = (event) => {
            if (!dropdownRef.current.contains(event.target)) {
                setOpen(false) 
            }
        }
        
        document.addEventListener("mousedown", handler)


        switch (model) {
            case "Species":
              Window.vms.selectedRegion(shocks)
              break;
      
            case "Gear":
              Window.vmg.selectedRegion(shocks)
              break;
      
            case "Charter":
              Window.vmc.selectedRegion(shocks)
              break;
          
            default:
               Window.vms.selectedRegion(shocks)
              break;
          }


        return () => {
            document.removeEventListener("mousedown", handler)
          }
    
    },[shocks])

    const selectShock = (item) => {
        let shocksUpdated = shocks.concat(item)
        setShocks(shocksUpdated)
    }

    const unselectShock = (shock) => {
        let shocksUpdated = shocks.filter(item => item.name !== shock.name)
        setShocks(shocksUpdated)
    }


    let filteredItems;
    switch (model) {
        case "Species":
          filteredItems = items[0].values.filter(i => shocks.indexOf(i) == -1)
          // Window.vms.selectedRegion(shock)
          break;
  
        case "Gear":
          filteredItems = items[1].values.filter(i => shocks.indexOf(i) == -1)
          // Window.vmg.selectedRegion(shock)
          break;
  
        case "Charter":
          filteredItems = items[2].values.filter(i => shocks.indexOf(i) == -1)
          // Window.vmc.selectedRegion(shock)
          break;
      
        default:
          filteredItems = items[0].values.filter(i => shocks.indexOf(i) == -1)
          //  Window.vms.selectedRegion(shock)
          break;
      }


    return (
        <div ref={dropdownRef} className="Selector">
            <div className="ShockSelectorTop">
                <h3 className="Header">Shock Vectors Filter</h3>
                <Tippy placement="right" content="Remove all values to display all shock vectors"><div><FontAwesomeIcon icon={faInfoCircle} /></div></Tippy> 
            </div>
            <div className="Dropdown">
                <div className="OptionSelected">
                    <div className="ValuesSelected">
                        { shocks.length != 0 ?
                            shocks.map(shock => (
                            <div className={`ValueSelected ${shock.type == "Sector" ? 'blue' : 'red'}`} onClick={() => unselectShock(shock)}>
                                <h3>{shock.name}</h3>
                                <FaTimes />
                            </div>
                            ))
                            :
                            <h3>All Values</h3>
                        }
                    </div>
                    <div className="chevronContainer" onClick={() => {setOpen(!open)}}>
                        <FontAwesomeIcon className={ open ? "chevronUp" : "chevronDown" } icon={faChevronDown} />
                    </div>
                </div>
                <div className={`${open ? "List" : "List_hidden"} ${filteredItems.length > 0 ? "" : "hidden"}`}>
                    <ul>
                    {filteredItems.filter(i => i.type == "Region").length > 0 ?
                        <li className="TitleList">Regions</li>
                            :
                        ''
                        }
                        {filteredItems.filter(i => i.type == "Region").map(item => (
                            <li className="Option" key={item.id} onClick={() => selectShock(item)}>
                                <h3 className="OptionName">{item.name}</h3>
                            </li>
                        ))}
                        {filteredItems.filter(i => i.type == "Sector").length > 0 ?
                        <li className="TitleList">Sectors</li>
                            :
                        ''
                        }
                        {filteredItems.filter(i => i.type == "Sector").map(item => (
                            <li className="Option" key={item.id} onClick={() => selectShock(item)}>
                                <h3 className="OptionName">{item.name}</h3>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>

            {/* This button is not needed, moving functionality to Reset Scenario Button in the Modal Dialog */}
            {/* <div className="ClearButton" onClick={clearInputs}>
                <h4>Clear Inputs</h4>
            </div> */}
        
        </div>
    );
};

export default ShockSelector;